import { IClaioRegistry, IClaioRepository } from "../../../domain/claio";
import { ClaioRepository } from ".";

export class ClaioRegistry implements IClaioRegistry {
  constructor(getToken: () => string) {
    this._repository = new ClaioRepository(getToken);
  }

  private readonly _repository: IClaioRepository;

  getClaioRepository(): IClaioRepository {
    return this._repository;
  }
}
